var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.disableClick ? 'cursor-default' : 'cursor-pointer'],attrs:{"id":"tr-like-increment"},on:{"click":_vm.increase}},[_vm._t("default",null,{"disableClick":_vm.disableClick,"currentLikes":_vm.currentLikes})],2)}
var staticRenderFns = []

export { render, staticRenderFns }